var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.92254V8.68604H15.75V16.2439C15.75 16.3775 15.6973 16.5057 15.6036 16.6002C15.5098 16.6947 15.3826 16.7478 15.25 16.7478H2.75C2.61739 16.7478 2.49021 16.6947 2.39645 16.6002C2.30268 16.5057 2.25 16.3775 2.25 16.2439V8.68604H1.25V6.92254L8.7025 1.34987C8.78859 1.28564 8.89288 1.25098 9 1.25098C9.10712 1.25098 9.21141 1.28564 9.2975 1.34987L16.75 6.92254Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7826 11.3893C12.1372 10.7993 12.2978 10.1115 12.2415 9.42406C12.1853 8.73661 11.9152 8.0846 11.4696 7.561C11.0239 7.0374 10.4257 6.66894 9.76002 6.50817C9.09438 6.3474 8.39535 6.40252 7.76263 6.66568L9.35263 8.26795C9.39911 8.31474 9.43599 8.37031 9.46116 8.43148C9.48632 8.49264 9.49927 8.55821 9.49927 8.62442C9.49927 8.69064 9.48632 8.7562 9.46116 8.81737C9.43599 8.87854 9.39911 8.93411 9.35263 8.9809L8.29263 10.0491C8.24619 10.0959 8.19105 10.1331 8.13035 10.1584C8.06965 10.1838 8.00458 10.1969 7.93888 10.1969C7.87317 10.1969 7.8081 10.1838 7.74741 10.1584C7.68671 10.1331 7.63156 10.0959 7.58513 10.0491L6.00013 8.44681C5.74931 9.0614 5.68995 9.73833 5.82993 10.3877C5.96991 11.0371 6.30261 11.6282 6.78385 12.0825C7.26509 12.5369 7.8721 12.8329 8.52426 12.9314C9.17642 13.0299 9.84288 12.9261 10.4351 12.6339",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 13.7245C12.5261 13.7245 12.75 13.4989 12.75 13.2207C12.75 12.9424 12.5261 12.7168 12.25 12.7168C11.9739 12.7168 11.75 12.9424 11.75 13.2207C11.75 13.4989 11.9739 13.7245 12.25 13.7245Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0181 10.9082L13.3256 12.2283C13.5835 12.5067 13.724 12.8751 13.7175 13.2558C13.711 13.6366 13.558 13.9999 13.2908 14.2691C13.0236 14.5384 12.6631 14.6926 12.2853 14.6991C11.9074 14.7057 11.5419 14.5641 11.2656 14.3042L9.82812 12.8581",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairs);
export default __webpack_public_path__ + "static/media/repairs.78cef8c9.svg";
export { ForwardRef as ReactComponent };